var preset = {
  shadow: {
    top: 'inset 0px 16px 12px -10px rgba(50, 57, 66, 0.08)',
    bottom: 'inset 0px -16px 12px -10px rgba(50, 57, 66, 0.08)',
    both: 'inset 0px 2px 12px 0px rgba(50, 57, 66, 0.08)',
    none: 'none'
  }
};

export { preset as default };
